import React from "react";
import logo from "assets/img/logo/logo_aig_login-2.png";

import {
  Card,
  CardBody,
  Row,
  Col,
  Label,
  Button,
  Alert
} from "reactstrap";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Textbox, Select as Select1, Textarea } from "react-inputs-validation";
import "../../../styles/estilos.css";
import Page from "components/Page";
import LoadingScreen from "react-loading-screen";
import { fetchConsultarIdentificacionAP } from "../../../redux/actions/aCotizacion"
import { fetchGuardarCarritoResponsabilidad } from "../../../redux/actions/aRamoLineaFinanciera"
import { encriptarTramaAES } from "../../../utils/Encriptar/index"
import makeAnimated from 'react-select/lib/animated';
import Select from 'react-select';
import { urlListarCiudadesFinanciero } from '../../../constants/urls'
import { FetchPost } from '../../../redux/actions/api'
import { ambienteAplicacion } from "../../../constants/urls";
import { guardCotizResp, setTipoCaso } from "../../../redux/actions/aCotizacionResponsabilidad";
import { provincias } from "../../../redux/actions/aRamoPymes";
import { EquiRamos, ErrorMsgConstants } from "../../../constants";
import { estaEnListaNegra, isDuplicateHogar } from "../../../redux/actions/ACarritoProductos";
import { ramos } from "../../../utils/constants";

class CotizacionResponsabilidad extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      validate: false,
      arrayDatos: {
        // cliente
        ruc: '',
        provincia: '',
        ciudad: '',
        cedula: '',
        empresa: '',
        solicitante: '',
        direccion: '',
        // empresa
        actividad: '',
        limite: '',
        facanual: '',
        giroNegocio: '',
        // sucursal
        sucursal: '',
        // otros
        nivelAcademico: '',
        tipoInstitucion: '',
        numEstudiantes: '',
        cliCodigoCore: '',
      },
      arrayCiudades: [],
      cargandoCiudades: false,
      arrayValidadores: {
        hasRucError: true,
        hasEmpresaError: true,
        hasCedulaError: true,
        hasSolicitanteError: true,
        hasDireccionError: true,
        hasProvinciaError: false,
        hasCiudadError: false,
        hasFacAnualError: true,
        hasActividadError: true,
        hasLimiteError: true,
        hasNivelAcademicoError: true,
        hasNumEstudiantesError: true,
        hasTipoInstitucionError: true,
        hasGiroNegocioError: false,
        hasSucursalError: true
      },
      idCarrito: "",
      valAlerta: false,
      valCampos: false,
    };
  }

  toggleValidating = (validate) => {
    this.setState({ validate });
  }
  validateForm = async () => {
    this.toggleValidating(true)
    const { arrayDatos, arrayValidadores, idCarrito } = this.state
    const { empresa, solicitante, ruc, cedula, direccion, facanual, limite, actividad, nivelAcademico, tipoInstitucion, numEstudiantes, cliCodigoCore, provincia, ciudad, giroNegocio, sucursal } = arrayDatos;
    const { hasEmpresaError, hasSolicitanteError, hasRucError, hasCedulaError, hasActividadError, hasLimiteError, hasFacAnualError, hasNivelAcademicoError,
      hasTipoInstitucionError, hasNumEstudiantesError, hasDireccionError, hasProvinciaError, hasCiudadError, hasGiroNegocioError, hasSucursalError } = arrayValidadores;

    console.log('hasActividadError,', hasActividadError, actividad);
    if (provincia === "")
      this.setState(prevState => ({ arrayValidadores: { ...prevState.arrayValidadores, hasProvinciaError: true } }))
    if (ciudad === "")
      this.setState(prevState => ({ arrayValidadores: { ...prevState.arrayValidadores, hasCiudadError: true } }))
    if (actividad === "")
      this.setState(prevState => ({ arrayValidadores: { ...prevState.arrayValidadores, hasActividadError: true } }))
    if (giroNegocio === "")
      this.setState(prevState => ({ arrayValidadores: { ...prevState.arrayValidadores, hasGiroNegocioError: false } }))

    // Determinar el tipo de responsabilidad civil
    const casoRc = new URLSearchParams(this.props.location.search).get('idProducto');
    console.log('caso_rc', casoRc);
    // Llamar al servicio de validación de duplicidad de poliza
    const checkDuplicidadObj = {
      empresa: "AIGMETROPOLITANA",
      plataforma: 'WEB',
      identificacion: ruc,
      ramo: casoRc === '122' ? EquiRamos.rcProfesional : EquiRamos.rcInstitucional,
    };
    console.log('checkDuplicidadObj pymes', checkDuplicidadObj, !this.props.duplicity.duplicidadPolizaError);
    await this.props.checkIsDuplicate({ type: 'otros', postObj: checkDuplicidadObj });

    console.log('test_if,',
      !hasEmpresaError,
      !hasSolicitanteError,
      !hasRucError,
      !hasCedulaError,
      !hasDireccionError,
      !hasProvinciaError,
      !hasCiudadError,
      !hasActividadError,
      !hasLimiteError,
      !hasFacAnualError,
      !hasNivelAcademicoError,
      !hasTipoInstitucionError,
      !hasNumEstudiantesError,
      !hasGiroNegocioError,
      !hasSucursalError,
      !this.props.duplicity.duplicidadPolizaError
    )
    // si es que no existe duplicidad, continuar al siguiente paso
    if (!this.props.duplicity.isDuplicatePoliza) {
      // Asignar error falso, a los campos que no se utilizan en el formulario
      if (
        !hasEmpresaError &&
        !hasSolicitanteError &&
        !hasRucError &&
        !hasCedulaError &&
        !hasDireccionError &&
        !hasProvinciaError &&
        !hasCiudadError &&
        !hasActividadError &&
        !hasLimiteError &&
        !hasFacAnualError &&
        !hasNivelAcademicoError &&
        !hasTipoInstitucionError &&
        !hasNumEstudiantesError &&
        !hasGiroNegocioError &&
        !hasSucursalError &&
        !this.props.duplicity.duplicidadPolizaError
      ) {
        console.log("VALIDO");
        const datosJSON = {
          codigoProducto: this.props.Cotizador.idProducto,
          numeroRuc: ruc,
          nombreEmpresa: empresa,
          provNombre: provincia.label,
          provCodigoCore: provincia.provCodigoCore ? provincia.provCodigoCore : provincia.value,
          paiCodigoCore: provincia.paiCodigoCore,
          ciuCodigoCore: ciudad.value,
          ciuNombre: ciudad.label,
          direccionPrincipal: direccion,
          cedulaSolicitante: cedula,
          nombreSolicitante: solicitante,
          codigoFacturacion: facanual,
          codigoActividad: actividad.value,
          codigoLimite: limite,
          codigoNivelAcademico: nivelAcademico,
          codigoTipoInstitucion: tipoInstitucion,
          codigoNumeroEstudiantes: numEstudiantes,
          idCarrito: this.props.ambosResp ? this.props.ambosResp.idCarrito : '',
          asesorCodigoCore: this.props.datosUsuario.cliCodigoCore,
          cliCodigoCore: cliCodigoCore,
          ambiente: ambienteAplicacion,
          // giroNegocio:{id:giroNegocio.value,nombre:giroNegocio.label},
          sucursalSeleccionada: sucursal,
          datosAsesor: {
            nombre: `${this.props.datosAsesor.nombres} ${this.props.datosAsesor.apellidos}`,
            codigoCore: this.props.datosAsesor.cliCodigoCore,
            sucursalSeleccionada: sucursal,
            ambiente: ambienteAplicacion,
            emailAsesor: this.props.datosAsesor.correo ? this.props.datosAsesor.correo : '',
            brokerRUC: this.props.datosAsesor.brokerRUC ? this.props.datosAsesor.brokerRUC : '',
            brokerNombre: this.props.datosAsesor.brokerNombre ? this.props.datosAsesor.brokerNombre : '',
            brokerCodigo: this.props.datosAsesor.brokerCodigo ? this.props.datosAsesor.brokerCodigo : '',
          },
        }
        const datosJSON2 = {
          paso: "1",
          datosCliente: datosJSON
        }
        console.log('datosJSON', datosJSON);
        const encriptado = await encriptarTramaAES(JSON.stringify(datosJSON2));
        await this.props.guardarCarrito({ "Data": Buffer.from(JSON.stringify(encriptado)).toString('base64'), "areaCotizador": this.props.Cotizador.areaCotizador });
        if (this.props.respuestaCarrito.respuestaGuardarResponsabilidad.transaccion === true) {
          // Guardar los datos de este paso, en caso de que regresen
          const cotizProf = {
            // datos cliente
            rucCli: ruc,
            nomEmpCli: empresa,
            provCli: provincia,
            ciuCli: ciudad,
            dirPriCli: direccion,
            cedCli: cedula,
            nomCli: solicitante,
            // datos empresa
            activEmp: actividad,
            limEmp: limite,
            factAnu: facanual,
            giroNeg: giroNegocio,
            // sucursal
            sucur: sucursal,
            // institucion
            nivAcad: nivelAcademico,
            tipInst: tipoInstitucion,
            numEst: numEstudiantes,
            // idCarrito
            idCarrito,
          }

          var nombreProducto = ''
          var codigoProducto = 0



          switch (parseInt(this.props.Cotizador.idProducto)) {
            case 123:

              var nombreProducto = 'Responsabilidad Civil Profesional Para Instituciones Educativas'
              var codigoProducto = 4

              break;

            case 121:

              nombreProducto = 'CyberEdge Express'
              codigoProducto = 1

              break;

            case 120:

              nombreProducto = 'D&O Express'
              codigoProducto = 2

              break;

            case 122:

              nombreProducto = 'Responsabilidad Civil Profesional'
              codigoProducto = 3

              break;

            default:
              break;
          }


          const datosAsesor = {

            sucursalSeleccionada: this.props.datosSucursales
              .sucursalSelecionadaAsesor,

            ambiente: ambienteAplicacion,
            emailAsesor: this.props.datosUsuarios.correo
              ? this.props.datosUsuarios.correo
              : "",
            nombreProducto: nombreProducto,
            codigoProducto: codigoProducto,
            codigoRamo: ramos.LINEAS_FINANCIERAS.codigo,
            nombreRamo: ramos.LINEAS_FINANCIERAS.nombre,
          }

          await this.props.checkInListaNegra(ruc, datosAsesor)
          if (this.props.datosListaNegra.inListaNegra === false) {

            await this.props.guardarCotizResp(cotizProf);

            // Siguiente paso, cuando todos los datos son correctos
            this.props.history.push({
              pathname: "/resumen-cotizacion-responsabilidad"
            });
          }

        } else {
          this.setState({
            valAlerta: true,
            idCarrito: this.props.respuestaCarrito.respuestaGuardarResponsabilidad.idCarrito
          });
        }
      } else {
        this.setState({
          valCampos: true
        });
        console.log("NO VALIDO");
      }
    }
  }

  consRucCedula = async params => {
    const { identificacion, tipo } = params;
    let datos = '';

    await this.props.consultarIdentificacion({
      "empresa": "AIGMETROPOLITANA",
      "identificador": identificacion,
      "tipo": tipo
    })

    if (Object.keys(this.props.datosIdentificacion.IdentificacionAP).length > 0)
      datos = this.props.datosIdentificacion.IdentificacionAP[0];

    const { nombre = '', mongoIdentificador = '', direccion = '', paiCodigoCore = '', provCodigoCore = '', provNombre = '', ciuCodigoCore = '', ciuNombre = '' } = datos;

    let prov = '';
    let ciu = '';
    let valSelect = true;

    if (provCodigoCore !== '' && provCodigoCore !== undefined && provCodigoCore !== null) {
      await this.onChangeProvincia(provCodigoCore);
      prov = {
        value: `${provCodigoCore ? provCodigoCore : ""}`,
        label: `${provNombre ? provNombre : ""}`,
        paiCodigoCore: `${paiCodigoCore ? paiCodigoCore : ""}`
      };

      ciu = {
        value: `${ciuCodigoCore ? ciuCodigoCore : ""}`,
        label: `${ciuNombre ? ciuNombre : ""}`
      };
      valSelect = false;
    }

    if (tipo === "ruc")
      this.setState(prevState => ({
        arrayDatos: {
          ...prevState.arrayDatos, empresa: `${nombre ? nombre : ""}`, direccion: `${direccion ? direccion : ""}`,
          cliCodigoCore: `${mongoIdentificador ? mongoIdentificador : ""}`, provincia: prov, ciudad: ciu
        },
        arrayValidadores: { ...prevState.arrayValidadores, hasProvinciaError: valSelect, hasCiudadError: valSelect }, validate: false,
      }))
    else if (tipo === "cedula")
      this.setState(prevState => ({ arrayDatos: { ...prevState.arrayDatos, solicitante: `${nombre ? nombre : ""}` }, validate: false }))

    setTimeout(() => this.setState({ validate: true }), 100)

  }

  onChangeProvincia = async (provincia) => {
    this.setState({ cargandoCiudades: true })
    let resp = await FetchPost({
      url: urlListarCiudadesFinanciero, param: {
        empresa: "AIGMETROPOLITANA",
        codProvincia: provincia,
        ramo: "lineasFinancieras"
      }
    })
    const { transaccion, ciudades } = resp
    if (transaccion) {
      this.setState({ arrayCiudades: ciudades })
    }
    this.setState({ cargandoCiudades: false })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.detalleCarrito !== prevProps.detalleCarrito)
      this.recuperarCarrito();
  }

  componentDidMount() {
    window.scroll(0, 0);
    this.recuperarCarrito();
  }

  async recuperarCarrito() {
    // en caso de que venga un usuario en this.props.detalleCarrito.datosCliente
    if ((this.props.detalleCarrito.datosCliente) && (Object.keys(this.props.detalleCarrito.datosCliente).length > 0)) {
      await this.onChangeProvincia(this.props.detalleCarrito.datosCliente.provCodigoCore);
      this.setState(prevState => ({
        arrayDatos: {
          ...prevState.arrayDatos,
          empresa: this.props.detalleCarrito.datosCliente.nombre,
          ruc: this.props.detalleCarrito.datosCliente.cedula,
          solicitante: this.props.detalleCarrito.datosCliente.nombreSolicitante,
          cedula: this.props.detalleCarrito.datosCliente.cedulaSolicitante,
          provincia: {
            value: this.props.detalleCarrito.datosCliente.provCodigoCore,
            label: this.props.detalleCarrito.datosCliente.provNombre,
            paiCodigoCore: this.props.detalleCarrito.datosCliente.paiCodigoCore,
          },
          ciudad: {
            value: this.props.detalleCarrito.datosCliente.ciuCodigoCore,
            label: this.props.detalleCarrito.datosCliente.ciuNombre
          },
          direccion: this.props.detalleCarrito.datosCliente.direccionPrincipal,
          actividad: this.props.detalleCarrito.actividad ? { value: this.props.detalleCarrito.actividad.codOpcion, label: this.props.detalleCarrito.actividad.nomOpcion } : '',
          limite: this.props.detalleCarrito.limite ? this.props.detalleCarrito.limite.codOpcion : '',
          facanual: this.props.detalleCarrito.facturacion ? this.props.detalleCarrito.facturacion.codOpcion : '',
          nivelAcademico: this.props.detalleCarrito.nivelAcademico ? this.props.detalleCarrito.nivelAcademico.codOpcion : '',
          tipoInstitucion: this.props.detalleCarrito.tipoInstitucion ? this.props.detalleCarrito.tipoInstitucion.codOpcion : '',
          numEstudiantes: this.props.detalleCarrito.numeroEstudiantes ? this.props.detalleCarrito.numeroEstudiantes.codOpcion : '',
          giroNegocio: { value: this.props.detalleCarrito.datosCliente.giroNegocio.id, label: this.props.detalleCarrito.datosCliente.giroNegocio.nombre },
          sucursal: this.props.detalleCarrito.datosAsesor.sucursalSeleccionada
        },
        arrayValidadores: {
          ...prevState.arrayValidadores,
          hasRucError: false,
          hasEmpresaError: false,
          hasCedulaError: false,
          hasSolicitanteError: false,
          hasDireccionError: false,
          hasProvinciaError: false,
          hasCiudadError: false,
          hasFacAnualError: false,
          hasActividadError: false,
          hasLimiteError: false,
          hasNivelAcademicoError: false,
          hasNumEstudiantesError: false,
          hasTipoInstitucionError: false,
          hasGiroNegocioError: false,
          hasSucursalError: false
        },
        idCarrito: this.props.detalleCarrito.ultimoPaso.resultado.idCarrito
      }))
    }
    // Si es que no vino un usuario en this.props.detalleCarrito.datosCliente
    // inicializar en vacio, a menos que este regresando, en ese caso inicializar
    // lo que guarda redux
    else {
      // determinar el caso que sea EMPRESA / INSTITUCION
      const queryProdId = new URLSearchParams(this.props.location.search);
      const casoUrl = queryProdId.get('idProducto');
      if (casoUrl) {
        const estadoActual = casoUrl === '122' ? 'empresa' : 'institucion';
        await this.props.setTipoCaso(estadoActual);
      }
      // revisar el estado guardado, para ambos casos
      let ambosResp = this.props.ambosResp;
      // si en redux, no esta un obj vacio
      let hasAmbosResp = false;
      if (ambosResp) {
        hasAmbosResp = Object.keys(ambosResp).length > 0;
      }
      // En caso de tener un estado guardado, cuando regresa a la pagina
      if (hasAmbosResp) {
        // Para estado de AMBOS casos
        this.setState(prevState => ({
          arrayDatos: {
            ...prevState.arrayDatos,
            ruc: ambosResp.rucCli,
            empresa: ambosResp.nomEmpCli,
            provincia: ambosResp.provCli,
            ciudad: ambosResp.ciuCli,
            direccion: ambosResp.dirPriCli,
            cedula: ambosResp.cedCli,
            solicitante: ambosResp.nomCli,
            sucursal: ambosResp.sucur,
          },
          arrayValidadores: {
            ...prevState.arrayValidadores,
            // revisar si los campos estan vacios ('') o tienen contenido
            // sin contenido, significa sin estado anterior guardado
            hasRucError: ambosResp.rucCli ? false : true,
            hasEmpresaError: ambosResp.nomEmpCli ? false : true,
            hasProvinciaError: ambosResp.provCli ? false : true,
            hasCiudadError: ambosResp.ciuCli ? false : true,
            hasDireccionError: ambosResp.dirPriCli ? false : true,
            hasCedulaError: ambosResp.cedCli ? false : true,
            hasSolicitanteError: ambosResp.nomCli ? false : true,
            hasSucursalError: ambosResp.sucur ? false : true,
          }, idCarrito: ambosResp.idCarrito,
        }))
      }
      let profResp = this.props.profResp;
      // si en redux, no esta un obj vacio
      let hasProfResp = false;
      if (profResp) {
        hasProfResp = Object.keys(profResp).length > 0;
      }
      // Para estado en caso de empresas
      if (this.props.tipoCaso === "empresa") {
        // desactivar aquellos que no se usan para este caso
        this.setState(prevState => ({
          arrayValidadores: {
            ...prevState.arrayValidadores,
            hasNivelAcademicoError: false,
            hasTipoInstitucionError: false,
            hasNumEstudiantesError: false,
          }
        }))
        // En caso de tener un estado anterior registrado
        console.log('hasProfResp,', hasProfResp, profResp);
        if (hasProfResp) {
          this.setState(prevState => ({
            arrayDatos: {
              ...prevState.arrayDatos,
              actividad: profResp.activEmp,
              limite: profResp.limEmp,
              facanual: profResp.factAnu,
              giroNegocio: profResp.giroNeg,
            },
            arrayValidadores: {
              ...prevState.arrayValidadores,
              // revisar si los campos estan vacios ('') o tienen contenido
              // sin contenido, significa sin estado anterior guardado
              hasActividadError: profResp.activEmp ? false : true,
              hasLimiteError: profResp.limEmp ? false : true,
              hasFacAnualError: profResp.factAnu ? false : true,
              hasGiroNegocioError: profResp.giroNeg ? false : true,
            }, idCarrito: '',
          }))
        }
      }

      // para estado en caso de instituciones
      let instResp = this.props.instResp;
      // si en redux, no esta un obj vacio
      let hasInstResp = false;

      if (instResp) {
        hasInstResp = Object.keys(instResp).length > 0;
      }
      if (this.props.tipoCaso === "institucion") {
        // desactivar aquellos que no se usan para este caso
        this.setState(prevState => ({
          arrayValidadores: {
            ...prevState.arrayValidadores,
            hasActividadError: false,
            hasLimiteError: false,
          }
        }))
        console.log('hasInstResp,', hasInstResp, instResp);
        // En caso de tener un estado anterior registrado
        if (hasInstResp) {
          this.setState(prevState => ({
            arrayDatos: {
              ...prevState.arrayDatos,
              nivelAcademico: instResp.nivAcad,
              tipoInstitucion: instResp.tipInst,
              numEstudiantes: instResp.numEst,
              facanual: instResp.factAnu,
              giroNegocio: instResp.giroNeg,
            },
            arrayValidadores: {
              ...prevState.arrayValidadores,
              // revisar si los campos estan vacios ('') o tienen contenido
              // sin contenido, significa sin estado anterior guardado
              hasNivelAcademicoError: instResp.nivAcad ? false : true,
              hasTipoInstitucionError: instResp.tipInst ? false : true,
              hasNumEstudiantesError: instResp.numEst ? false : true,
              hasFacAnualError: instResp.factAnu ? false : true,
              hasGiroNegocioError: instResp.giroNeg ? false : true,
            }, idCarrito: '',
          }))
        }
      }
    }
  }


  textosCargando() {
    const { cargandoCiudades } = this.state;

    if (this.props.respuestaCarrito.guardarCarritoResponsabilidadIsLoading)
      return "Guardando información. Por favor espere..."
    if (this.props.datosIdentificacion.consultarIdentificacionAPIsLoading)
      return "Cargando datos..."
    if (cargandoCiudades)
      return "Consultado ciudades..."

  }
  render() {
    // asignar los valores de error en falso
    // si es que recibimos los valores iniciales de redux
    // hasActividadError = actividad ? false : true;
    // hasGiroNegocioError = giroNegocio ? false : true;
    // hasProvinciaError = provincia  ? false : true;
    // hasCiudadError = ciudad ? false : true;

    // constantes en el render
    const { validate, valAlerta, valCampos, arrayDatos, arrayValidadores, arrayCiudades, cargandoCiudades } = this.state;
    const { respuestaCarrito, datosIdentificacion, dataResponsabilidad, Cotizador, listarProvincias, listaGirosNegocio, listaSucursales } = this.props;
    const { nombreCotizador, areaCotizador } = Cotizador;
    const { hasProvinciaError, hasCiudadError, hasActividadError, hasGiroNegocioError } = arrayValidadores;
    const { empresa, solicitante, ruc, cedula, direccion, facanual, limite, actividad, nivelAcademico, tipoInstitucion, numEstudiantes, provincia, ciudad, giroNegocio, sucursal } = arrayDatos;

    let arraySucursales = [];
    listaSucursales.map(s => {
      arraySucursales.push({ id: s.sucCodigoCore, name: s.sucNombre });
    });
    arraySucursales.unshift({ id: '', name: 'Seleccione una opción' });

    return (
      <LoadingScreen
        loading={datosIdentificacion.consultarIdentificacionAPIsLoading ||
          respuestaCarrito.guardarCarritoResponsabilidadIsLoading ||
          cargandoCiudades ||
          this.props.duplicity.duplicidadPolizaLoading
        }
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        logoSrc={logo}
        text={this.textosCargando()}
      >
        {/*Test block */}
        {/* <div>
        TEST
        {`${ruc}`}
        {empresa}
        {provincia}
        {ciudad}
        {direccion}
        {cedula}
        {solicitante}
        {actividad}
        {limite}
        {facanual}
        {giroNegocio}
        {sucursal}
      </div> */}

        <Page
          title={nombreCotizador}
          breadcrumbs={[{ name: `${nombreCotizador}`, active: true }]}
        >
          <div className="container-step">
            <div className="wrapper-step">
              <div className="arrow-steps clearfix-step">
                <div className="step current"> {` 1. Cotización `} </div>
                <div className="step"> {` 2. Resumen `} </div>
                <div className="step"> {` 3. Confirmación `} </div>
                <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
              </div>
            </div>
          </div>
          <Row>
            <Col lg={8} md={12} sm={12} xs={12} className="div-align-center">
              <Card className="flex-row ">
                <CardBody>
                  <h4 style={{ fontWeight: "bold" }} className='mb-5'> Datos del Cliente </h4>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <h5><Label className="bold-font-label" >RUC(*) </Label></h5>
                      </Col>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Textbox
                          tabIndex="1"
                          type="text"
                          value={ruc}
                          name="ruc"
                          id="ruc"
                          classNameInput={"form-control"}
                          onBlur={() => { this.setState({ valAlerta: false, valCampos: false }); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          onChange={(ruc, e) => {
                            this.setState(prevState => ({
                              arrayDatos: { ...prevState.arrayDatos, ruc },
                              arrayValidadores: { ...prevState.arrayValidadores, hasRucError: ruc ? false : true }, valAlerta: false, valCampos: false
                            }));
                            if (ruc.length === 13) {
                              this.consRucCedula({ identificacion: ruc, tipo: "ruc" })
                            }
                          }}
                          validate={validate}
                          validationCallback={res => this.setState(prevState => ({ arrayValidadores: { ...prevState.arrayValidadores, hasRucError: res }, validate: false }))}// Optional.[Func].Default: none. Return the validation result.
                          validationOption={{
                            name: "ruc", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            reg: /^\d{13}$/, //Optional.[Bool].Default: "" Custom regex.
                            msgOnError: "Por favor ingrese un RUC correcto" // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <h5><Label className="bold-font-label" >Nombre de la empresa(*)  </Label></h5>
                      </Col>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Textarea
                          tabIndex="1"
                          type="input"
                          value={empresa}
                          name="empresa"
                          id="empresa"
                          classNameInput={"form-control"}
                          onChange={(empresa, e) => this.setState(prevState => ({
                            arrayDatos: { ...prevState.arrayDatos, empresa: empresa.toUpperCase() },
                            arrayValidadores: { ...prevState.arrayValidadores, hasEmpresaError: empresa ? false : true }, valAlerta: false, valCampos: false
                          }))}
                          onBlur={() => { this.setState({ valAlerta: false, valCampos: false }); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          validate={validate}
                          validationCallback={res => this.setState(prevState => ({ arrayValidadores: { ...prevState.arrayValidadores, hasEmpresaError: res }, validate: false }))}// Optional.[Func].Default: none. Return the validation result.
                          validationOption={{
                            name: "empresa", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: false, // Optional.[Bool].Default: true. To determin if it is a required field.
                            //msgOnError: "Debe ingresar una dirección." // Optional.[Bool].Default: true. To determin if it is a required field.
                            customFunc: res => {
                              //Optional.[Func].Default: none. Custom function. Returns true or err message
                              res = empresa;
                              if (
                                res === "" ||
                                res === null ||
                                res === undefined
                              ) {
                                return "Por favor ingrese el nombre de la empresa.";
                              }
                              return true;
                            }
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <h5><Label className="bold-font-label" >Provincia (*)</Label></h5>
                      </Col>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Select
                          value={provincia}
                          components={makeAnimated()}
                          onChange={(provincia, e) => {
                            this.setState(prevState => ({
                              arrayDatos: { ...prevState.arrayDatos, provincia, ciudad: '' },
                              arrayValidadores: { ...prevState.arrayValidadores, hasProvinciaError: provincia ? false : true }, valAlerta: false, valCampos: false
                            }))
                            this.onChangeProvincia(provincia.value.toString())
                          }}
                          options={listarProvincias}
                          isSearchable={true}
                          placeholder={"Seleccione una provincia"}
                          isMulti={false}
                        />
                        {hasProvinciaError &&
                          <span style={{ color: "#ff5a57", fontSize: "1rem", marginLeft: "5px" }}>Por favor seleccione una provincia</span>
                        }
                      </Col>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <h5><Label className="bold-font-label" >Ciudad (*)</Label></h5>
                      </Col>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Select
                          value={ciudad}
                          components={makeAnimated()}
                          onChange={(ciudad, e) => {
                            this.setState(prevState => ({
                              arrayDatos: { ...prevState.arrayDatos, ciudad },
                              arrayValidadores: { ...prevState.arrayValidadores, hasCiudadError: ciudad ? false : true }, valAlerta: false, valCampos: false
                            }))
                          }}
                          options={arrayCiudades}
                          isSearchable={true}
                          placeholder={"Seleccione una ciudad"}
                          isMulti={false}
                        />
                        {hasCiudadError &&
                          <span style={{ color: "#ff5a57", fontSize: "1rem", marginLeft: "5px" }}>Por favor seleccione una ciudad</span>
                        }
                      </Col>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <h5><Label className="bold-font-label" >Direción principal de la empresa solicitante (*)</Label></h5>
                      </Col>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Textarea
                          // tabIndex="1"
                          type="text"
                          value={direccion}
                          name="direccion"
                          id="direccion"
                          classNameInput={"form-control"}
                          validate={validate}
                          onChange={(direccion, e) => this.setState(prevState => ({
                            arrayDatos: { ...prevState.arrayDatos, direccion: direccion.toUpperCase() },
                            arrayValidadores: { ...prevState.arrayValidadores, hasDireccionError: direccion ? false : true }, valAlerta: false, valCampos: false
                          }))}
                          onBlur={() => { this.setState({ valAlerta: false, valCampos: false }); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          validationCallback={res => this.setState(prevState => ({ arrayValidadores: { ...prevState.arrayValidadores, hasDireccionError: res }, validate: false }))}// Optional.[Func].Default: none. Return the validation result.
                          validationOption={{
                            name: 'direccion', // Optional.[String].Default: "". To display in the Error message. i.e Please enter your {name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: false, // Optional.[Bool].Default: true. To determin if it is a required field.
                            //msgOnError: "Debe ingresar una dirección." // Optional.[Bool].Default: true. To determin if it is a required field.
                            customFunc: res => {
                              //Optional.[Func].Default: none. Custom function. Returns true or err message
                              res = direccion
                              if (res === "" || res === null || res === undefined) {
                                this.setState({ direccion: "" });
                                return "Por favor ingrese una dirección.";
                              }
                              return true;
                            }
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <h5><Label className="bold-font-label" >CI de Solicitante(*) </Label></h5>
                      </Col>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Textbox
                          tabIndex="1"
                          type="text"
                          value={cedula}
                          name="cedula"
                          id="cedula"
                          classNameInput={"form-control"}
                          onBlur={() => { this.setState({ valAlerta: false, valCampos: false }); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          onChange={(cedula, e) => {
                            this.setState(prevState => ({
                              arrayDatos: { ...prevState.arrayDatos, cedula },
                              arrayValidadores: { ...prevState.arrayValidadores, hasCedulaError: cedula ? false : true }, valAlerta: false, valCampos: false
                            }));
                            if (cedula.length === 10) {
                              this.consRucCedula({ identificacion: cedula, tipo: "cedula" })
                            }
                          }}
                          validate={validate}
                          validationCallback={res => this.setState(prevState => ({ arrayValidadores: { ...prevState.arrayValidadores, hasCedulaError: res }, validate: false }))}// Optional.[Func].Default: none. Return the validation result.
                          validationOption={{
                            name: "cedula", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true,
                            reg: /^\d{10}$/, //Optional.[Bool].Default: "" Custom regex.
                            msgOnError: "Por favor ingrese una Cédula correcta" // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <h5><Label className="bold-font-label" >Nombre del solicitante(*) </Label></h5>
                      </Col>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Textbox
                          tabIndex="1"
                          type="text"
                          value={solicitante}
                          name="solicitante"
                          id="solicitante"
                          classNameInput={"form-control"}
                          onChange={(solicitante, e) => this.setState(prevState => ({
                            arrayDatos: { ...prevState.arrayDatos, solicitante },
                            arrayValidadores: { ...prevState.arrayValidadores, hasSolicitanteError: solicitante ? false : true }, valAlerta: false, valCampos: false
                          }))}
                          onBlur={() => { this.setState({ valAlerta: false, valCampos: false }); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          validate={validate}
                          validationCallback={res => this.setState(prevState => ({ arrayValidadores: { ...prevState.arrayValidadores, hasSolicitanteError: res }, validate: false }))}// Optional.[Func].Default: none. Return the validation result.
                          validationOption={{
                            name: "solicitante", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            reg: /^[\u00e1\u00e9\u00ed\u00f3\u00fa\u00c1\u00c9\u00cd\u00d3\u00da\u00f1\u00d1A-Za-z _]*$/,
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor ingrese un nombre de solicitante válido" // Optional.[Bool].Default: true. To determin if it is a required field.
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>
                  <hr></hr>
                  <h4 style={{ fontWeight: "bold" }} className='mb-5'> Datos de la empresa </h4>
                  {areaCotizador === "empresa" &&
                    <div>
                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                          <Col lg={12} md={12} sm={12} xs={12}>
                            <h5><Label className="bold-font-label" >Actividad(*) </Label></h5>
                          </Col>
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                          <Col lg={8} md={8} sm={12} xs={12}>
                            <Select
                              value={actividad}
                              components={makeAnimated()}
                              onChange={(actividad, e) => {
                                this.setState(prevState => ({
                                  arrayDatos: { ...prevState.arrayDatos, actividad },
                                  arrayValidadores: { ...prevState.arrayValidadores, hasActividadError: actividad ? false : true }, valAlerta: false, valCampos: false
                                }))
                              }}
                              options={dataResponsabilidad.selectActividades}
                              onBlur={() => { this.setState({ valAlerta: false, valCampos: false }); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              isSearchable={true}
                              placeholder={"Seleccione una actividad"}
                              isMulti={false}
                            />
                            {hasActividadError &&
                              <span style={{ color: "#ff5a57", fontSize: "1rem", marginLeft: "5px" }}>Por favor seleccione una actividad</span>
                            }
                          </Col>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                          <Col lg={12} md={12} sm={12} xs={12}>
                            <h5><Label className="bold-font-label" >Límite por evento y agregado anual(*) </Label></h5>
                          </Col>
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                          <Col lg={8} md={8} sm={12} xs={12}>
                            <Select1
                              //tabIndex="6" // Optional.[String or Number].Default: none.
                              id={"limite"} // Optional.[String].Default: "". Input ID.
                              name={"limite"} // Optional.[String].Default: "". Input name.
                              value={limite} // Optional.[String].Default: "".
                              validate={validate}
                              optionList={dataResponsabilidad.selectLimites} // Required.[Array of Object(s)].Default: [].
                              onChange={(limite, e) => {
                                this.setState(prevState => ({
                                  arrayDatos: { ...prevState.arrayDatos, limite },
                                  arrayValidadores: { ...prevState.arrayValidadores, hasLimiteError: limite ? false : true }, valAlerta: false, valCampos: false
                                }))
                              }}
                              onBlur={() => { this.setState({ valAlerta: false, valCampos: false }); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              validationCallback={res => this.setState(prevState => ({ arrayValidadores: { ...prevState.arrayValidadores, hasLimiteError: res }, validate: false }))}// Optional.[Func].Default: none. Return the validation result.                                                                  
                              customStyleOptionListContainer={{ maxHeight: '200px', overflow: 'auto', fontSize: '14px' }} // Optional.[Object].Default: {}.
                              validationOption={{
                                name: "limite", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione un límite"
                              }}
                            />
                          </Col>
                        </Col>
                      </Row>
                    </div>
                  }
                  {areaCotizador === "institucion" &&
                    <div>
                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                          <Col lg={12} md={12} sm={12} xs={12}>
                            <h5><Label className="bold-font-label" >Nivel Académico(*) </Label></h5>
                          </Col>
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                          <Col lg={8} md={8} sm={12} xs={12}>
                            <Select1
                              //tabIndex="6" // Optional.[String or Number].Default: none.
                              id={"nivelAcademico"} // Optional.[String].Default: "". Input ID.
                              name={"nivelAcademico"} // Optional.[String].Default: "". Input name.
                              value={nivelAcademico} // Optional.[String].Default: "".
                              validate={validate}
                              optionList={dataResponsabilidad.selectNivelAcademico} // Required.[Array of Object(s)].Default: [].
                              onChange={(nivelAcademico, e) => this.setState(prevState => ({
                                arrayDatos: { ...prevState.arrayDatos, nivelAcademico },
                                arrayValidadores: { ...prevState.arrayValidadores, hasNivelAcademicoError: nivelAcademico ? false : true }, valAlerta: false, valCampos: false
                              }))}
                              onBlur={() => { this.setState({ valAlerta: false, valCampos: false }); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              validationCallback={res => this.setState(prevState => ({ arrayValidadores: { ...prevState.arrayValidadores, hasNivelAcademicoError: res }, validate: false }))}// Optional.[Func].Default: none. Return the validation result.                                                                  
                              customStyleOptionListContainer={{ maxHeight: '210px', overflow: 'auto', fontSize: '14px' }} // Optional.[Object].Default: {}.
                              validationOption={{
                                name: "nivelAcademico", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione un nivel académico"
                              }}
                            />
                          </Col>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                          <Col lg={12} md={12} sm={12} xs={12}>
                            <h5><Label className="bold-font-label" >Tipo de Institución(*) </Label></h5>
                          </Col>
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                          <Col lg={8} md={8} sm={12} xs={12}>
                            <Select1
                              //tabIndex="6" // Optional.[String or Number].Default: none.
                              id={"tipoInstitucion"} // Optional.[String].Default: "". Input ID.
                              name={"tipoInstitucion"} // Optional.[String].Default: "". Input name.
                              value={tipoInstitucion} // Optional.[String].Default: "".
                              validate={validate}
                              optionList={dataResponsabilidad.selectTipoInstitucion} // Required.[Array of Object(s)].Default: [].
                              onChange={(tipoInstitucion, e) => this.setState(prevState => ({
                                arrayDatos: { ...prevState.arrayDatos, tipoInstitucion },
                                arrayValidadores: { ...prevState.arrayValidadores, hasTipoInstitucionError: tipoInstitucion ? false : true }, valAlerta: false, valCampos: false
                              }))}
                              onBlur={() => { this.setState({ valAlerta: false, valCampos: false }); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              validationCallback={res => this.setState(prevState => ({ arrayValidadores: { ...prevState.arrayValidadores, hasTipoInstitucionError: res }, validate: false }))}// Optional.[Func].Default: none. Return the validation result.                                                                                        
                              customStyleOptionListContainer={{ maxHeight: '210px', overflow: 'auto', fontSize: '14px' }} // Optional.[Object].Default: {}.
                              validationOption={{
                                name: "tipoInstitucion", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione un tipo de institucion"
                              }}
                            />
                          </Col>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                          <Col lg={12} md={12} sm={12} xs={12}>
                            <h5><Label className="bold-font-label" >Número de Estudiantes(*) </Label></h5>
                          </Col>
                        </Col>
                        <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                          <Col lg={8} md={8} sm={12} xs={12}>
                            <Select1
                              //tabIndex="6" // Optional.[String or Number].Default: none.
                              id={"numEstudiantes"} // Optional.[String].Default: "". Input ID.
                              name={"numEstudiantes"} // Optional.[String].Default: "". Input name.
                              value={numEstudiantes} // Optional.[String].Default: "".
                              validate={validate}
                              optionList={dataResponsabilidad.selectNumEstudiantes} // Required.[Array of Object(s)].Default: [].
                              onChange={(numEstudiantes, e) => this.setState(prevState => ({
                                arrayDatos: { ...prevState.arrayDatos, numEstudiantes },
                                arrayValidadores: { ...prevState.arrayValidadores, hasNumEstudiantesError: numEstudiantes ? false : true }, valAlerta: false, valCampos: false
                              }))}
                              onBlur={() => { this.setState({ valAlerta: false, valCampos: false }); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                              validationCallback={res => this.setState(prevState => ({ arrayValidadores: { ...prevState.arrayValidadores, hasNumEstudiantesError: res }, validate: false }))}// Optional.[Func].Default: none. Return the validation result.                                                                  
                              customStyleOptionListContainer={{ maxHeight: '210px', overflow: 'auto', fontSize: '14px' }} // Optional.[Object].Default: {}.
                              validationOption={{
                                name: "numEstudiantes", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                msgOnError: "Por favor seleccione el número de estudiantes"
                              }}
                            />
                          </Col>
                        </Col>
                      </Row>
                    </div>
                  }
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <h5><Label className="bold-font-label" >Facturación Anual(*) </Label></h5>
                      </Col>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Select1
                          //tabIndex="6" // Optional.[String or Number].Default: none.
                          id={"facanual"} // Optional.[String].Default: "". Input ID.
                          name={"facanual"} // Optional.[String].Default: "". Input name.
                          value={facanual} // Optional.[String].Default: "".
                          validate={validate}
                          optionList={dataResponsabilidad.selectFacturacion} // Required.[Array of Object(s)].Default: [].
                          onChange={
                            (facanual, e) => {
                              this.setState(prevState => ({
                                arrayDatos: { ...prevState.arrayDatos, facanual },
                                arrayValidadores: { ...prevState.arrayValidadores, hasFacAnualError: facanual ? false : true }, valAlerta: false, valCampos: false
                              }))
                            }}
                          onBlur={() => { this.setState({ valAlerta: false, valCampos: false }); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          validationCallback={res => this.setState(prevState => ({ arrayValidadores: { ...prevState.arrayValidadores, hasFacAnualError: res }, validate: false }))}// Optional.[Func].Default: none. Return the validation result.                                                                  
                          customStyleOptionListContainer={{ maxHeight: '210px', overflow: 'auto', fontSize: '14px' }} // Optional.[Object].Default: {}.
                          validationOption={{
                            name: "actividad", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor seleccione su facturación anual"
                          }}
                        />
                        <span style={{ fontSize: "11px" }}>Si la facturación es mayor a de USD $ 500.000,00 contactarse con ecuador.comercial@aig.com</span>
                      </Col>
                    </Col>
                  </Row>
                  {/* <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <h5><Label className="bold-font-label" >Giro de Negocio (*)</Label></h5>
                        </Col>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Select
                          value={giroNegocio}
                          components={makeAnimated()}
                          onChange={(giroNegocio, e) =>{
                            this.setState(prevState => ({ arrayDatos: { ...prevState.arrayDatos, giroNegocio}, 
                            arrayValidadores: { ...prevState.arrayValidadores, hasGiroNegocioError: giroNegocio ? false : true}, valAlerta: false, valCampos: false  })) }}
                          options={listaGirosNegocio}
                          onBlur={() => {this.setState({ valAlerta: false, valCampos: false}); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          isSearchable={true}
                          placeholder={"Seleccione un giro de negocio"}
                          isMulti={false}
                        />
                        { hasGiroNegocioError &&
                          <span style={{ color: "#ff5a57", fontSize: "1rem", marginLeft:"5px"}}>Por favor seleccione un giro de negocio</span>
                        }                          
                      </Col>
                    </Col>
                  </Row>   */}
                  <hr></hr>
                  <h4 style={{ fontWeight: "bold" }} className='mb-5'> Sucursal de emisión</h4>
                  <Row>
                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <h5><Label className="bold-font-label" >Sucursal (*)</Label></h5>
                      </Col>
                    </Col>
                    <Col lg={8} md={8} sm={12} xs={12} className="mb-3">
                      <Col lg={8} md={8} sm={12} xs={12}>
                        <Select1
                          //tabIndex="6" // Optional.[String or Number].Default: none.
                          id={"selecSucursal"} // Optional.[String].Default: "". Input ID.
                          name={"selecSucursal"} // Optional.[String].Default: "". Input name.
                          value={sucursal} // Optional.[String].Default: "".
                          validate={validate}
                          optionList={arraySucursales} // Required.[Array of Object(s)].Default: [].
                          onChange={(sucursal, e) => {
                            this.setState(prevState => ({
                              arrayDatos: { ...prevState.arrayDatos, sucursal },
                              arrayValidadores: { ...prevState.arrayValidadores, hasSucursalError: sucursal ? false : true }, valAlerta: false, valCampos: false
                            }))
                          }}
                          onBlur={() => { this.setState({ valAlerta: false, valCampos: false }); }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                          validationCallback={res => this.setState(prevState => ({ arrayValidadores: { ...prevState.arrayValidadores, hasActividadError: false, hasSucursalError: res }, validate: false }))}// Optional.[Func].Default: none. Return the validation result.                                                                  
                          customStyleOptionListContainer={{ maxHeight: '210px', overflow: 'auto', fontSize: '14px' }} // Optional.[Object].Default: {}.
                          validationOption={{
                            name: "selecSucursal", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                            msgOnError: "Por favor seleccione una sucursal"
                          }}
                        />
                      </Col>
                    </Col>
                  </Row>
                  {valAlerta &&
                    <Row >
                      <Col lg={12} md={12} sm={12} xs={12} className="div-align-center">
                        <Alert color="warning">
                          <p style={{ textAlign: "center" }}><i className="fa fa-exclamation-triangle fa-3x" aria-hidden="true" ></i></p>
                          <p>{respuestaCarrito.respuestaGuardarResponsabilidad.errorDescripcion}</p>

                        </Alert>
                      </Col>
                    </Row>
                  }
                  {valCampos &&
                    <Row >
                      <Col md={10} sm={12} className="div-align-center">
                        <Alert color="danger">
                          <p style={{ textAlign: "center" }}><i className="fa fa-exclamation-triangle fa-2x" aria-hidden="true" ></i></p>
                          <p style={{ textAlign: "center" }}>{"Para continuar debe ingresar los campos obligatorios marcados con (*)"}</p>

                        </Alert>
                      </Col>
                    </Row>
                  }
                  <Row>
                    <div className="div-align-rigth">
                      <Button className="btn btn-primary" onClick={this.validateForm} style={{ display: "block", margin: "auto" }} >
                        <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                        {"CONTINUAR"}
                      </Button>
                    </div>
                  </Row>
                  {/* Mensaje de error*/}
                  <div style={{ marginTop: '2rem' }}>
                    {/* Validacion de duplicidad */}
                    {console.log('test dup msg', this.props.duplicity)}
                    {this.props.duplicity.isDuplicatePoliza
                      ?
                      <Alert color="danger">
                        <center><p>{ErrorMsgConstants.duplicidad}</p></center>
                      </Alert>
                      :
                      null
                    }
                    {this.props.duplicity.duplicidadPolizaError &&
                      <Alert color="danger" >
                        <center><p>{ErrorMsgConstants.errorServicioDuplicidad}</p></center>
                      </Alert>
                    }
                  </div>

                  <div style={{ marginTop: '2rem' }}>
                    {/* Validacion de duplicidad */}
                    {console.log('test dup msg', this.props.datosListaNegra)}
                    {this.props.datosListaNegra.inListaNegra
                      ?
                      <Alert color="danger">
                        <center><p>{this.props.datosListaNegra.inListaNegraMensaje}</p></center>
                      </Alert>
                      :
                      null
                    }
                    {this.props.datosListaNegra.listaNegraError &&
                      <Alert color="danger">
                        <center><p>{ErrorMsgConstants.errorServicioListaNegra}</p></center>
                      </Alert>
                    }
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Page>
      </LoadingScreen>

    );
  }
}

const mapStateToProps = state => ({
  datosIdentificacion: state.datosIdentificacionAP,
  respuestaCarrito: state.datosCotizacionResponsabilidad,
  datosUsuario: state.datosUsuarios.dataUsuario,
  datosAsesor: state.datosUsuarios.dataUsuario,
  // guardar estados para cuando regresen a esta pagina
  tipoCaso: state.rCotizacionResp.estado,
  ambosResp: state.rCotizacionResp.ambos,
  profResp: state.rCotizacionResp.profesional,
  instResp: state.rCotizacionResp.institucion,
  duplicity: state.datosDuplicidadPolizas,
  datosListaNegra: state.datosListaNegra,
  datosUsuarios: state.datosUsuarios.dataUsuario,
  datosSucursales: state.datosSucursales
});

const mapDispatchToProps = dispatch => {
  return {
    consultarIdentificacion: datos => dispatch(fetchConsultarIdentificacionAP(datos)),
    guardarCarrito: data => dispatch(fetchGuardarCarritoResponsabilidad(data)),
    setTipoCaso: data => dispatch(setTipoCaso(data)),
    guardarCotizResp: data => dispatch(guardCotizResp(data)),
    checkIsDuplicate: (datosCheckDuplicity) => dispatch(isDuplicateHogar(datosCheckDuplicity)),
    checkInListaNegra: (identificacion, datos) => dispatch(estaEnListaNegra(identificacion, datos)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CotizacionResponsabilidad)
);